@if (columnParamsStateService.columnParamsState().length) {
  <div
    class="group-header"
    appScrollSync
    [sourceName]=`${resourceParamsKey}-group-header`
    [syncGroup]="resourceParamsKey"
  >
    @for (columnParam of columnParamsStateService.getColumnParamsByKey(resourceParamsKey); track columnParam.key) {
      @if (isColumnDisplayed(columnParam)) {
        <div
          class="group-cell"
          [class.sticky]="columnParam.sticky"
          [style]="getLeftPositionForSticky(columnParam.leftPositionForStickyColumn)"
          [style.max-width.px]="getWidth(columnParam)"
          [style.min-width.px]="getWidth(columnParam)"
        >
          @if (isColumnInGroupShouldBeDisplayed(columnParam)) {
            <div
              class="group"
              [class]="{
                'first-column-in-group': isGroupControllerDisplayed(columnParam),
                'last-column-in-group': isLastColumnInGroup(columnParam),
                'controller-in-hidden-group': isGroupControllerDisplayed(columnParam) && columnParam.hiddenGroup
               }"
              [style]="{'--group-color': getGroupColor(columnParam)}"
            >
              @if (isGroupControllerDisplayed(columnParam)) {
                <div class="group-controller">
                  <button
                    mat-icon-button
                    class="group-controller-button"
                    [style.color]="getGroupColor(columnParam)"
                    (click)="toggleGroupVisibility(columnParam)"
                  >
                    <mat-icon class="group-controller-button-icon">folder_open</mat-icon>
                  </button>
                  @if (!columnParam.hiddenGroup) {
                    <div class="group-name">
                      {{ columnParam.columnProperties.GROUP?.name }}
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
      }
      @if (columnParam.separated) {
        <div class="separator-column"></div>
      }
    }
    @if (isAnyTableActionAvailable) {
      <div class="table-cell table-action"></div>
    }
  </div>
}
